import { Theme } from "@mui/material";

export const bookingHeaderStyles = {
  bookingHeader: {
    marginTop: "20px",
    alignItems: "center",
  },
  headerLeftContainer: {
    display: "flex",
    justifyContent: { xs: "center", sm: "flex-start" },
    textAlign: { xs: "center", sm: "flex-start" },
  },
  headerMainText: {
    fontSize: "44px",
    fontWeight: 700,
    color: "#000",

    marginBottom: { xs: "10px", sm: "0px" },
  },

  headerMidContainer: { display: "flex", justifyContent: "center" },

  toggleContainer: {
    display: "flex",
    borderRadius: "25px",
    border: "1px solid black",
  },

  bookingToggle: (activeTab: string, tab: string) => ({
    backgroundColor: activeTab === tab ? "black" : "white",
    borderTopLeftRadius: "25px",
    borderBottomLeftRadius: "25px",
    px: {
      xs: 2,
      sm: 10,
    },

    py: 1,
    cursor: "pointer",
  }),

  refferalToggle: (activeTab: string, tab: string) => ({
    backgroundColor: activeTab === tab ? "black" : "white",
    borderTopRightRadius: "25px",
    borderBottomRightRadius: "25px",
    px: {
      xs: 2,
      sm: 10,
    },
    py: 1,
    cursor: "pointer",
  }),

  toggleHeading: (activeTab: string, tab: string) => ({
    color: activeTab === tab ? "white" : "black",
    fontSize: '15px',
    fontWeight: "600"
  }),

  headerRightContainer: {
    display: "flex",
    justifyContent: { xs: "center", sm: "flex-end" },
  },

  calenderContainer: {
    display: "flex",
    flexDirection: {xs: "column", md: "row"},
    justifyContent: "space-between",
    alignItems: "center",
    my: "20px",
    gap: "10px"
    // mx: "20px",
  },

  leftContainer: { display: "flex", flexDirection: "column" },
  leftContainerBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
  },
  dateText: {
    fontSize: "20px",
    marginRight: "10px",
    display: "flex",
    alignItems: "center"
  },
  reservationText: {
    fontSize: "11px",
    color: "#8D8D8D",
    mt: "-7px",
  },
  rightContainer: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    border: "1px solid #8D8D8D",
    padding: "5px 14px",
    borderRadius: "28px",
    cursor: "pointer",
    width: 188
  },
  rightContainerText: { fontSize: "15px", color: "#595959", fontWeight: "600" },
  filledButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "174px",
    backgroundColor: "#328734",
    "&:hover": {
      backgroundColor: "#328734",
    },
    borderRadius: "8px"
  },
  filledButtonTypography: (theme: Theme) => ({
      fontSize: "13px",
      fontWeight: 500,
      color: "#fff",
      fontFamily: theme.typography.fontFamily,
    }),
};
